jQuery(document).ready(function ($) {
	// Get the value that determines the default sort column
	var defaultValue = $('#alps-reviews-table').attr('data-default_sort'); // Replace with your actual value or logic
	var defaultOrder = 'asc';
	if ('popular' == defaultValue || 'rating' == defaultValue) {
		defaultOrder = 'desc';
	}
	// Find the index of the column based on the value
	var columnIndex = 0; // Initialize with an invalid index
	if ('popular' == defaultValue) {
		columnIndex = 2;
	} else if ('rating' == defaultValue) {
		columnIndex = 0;
	} else if ('name' == defaultValue) {
		columnIndex = 1;
	}
	$('#alps-reviews-table').DataTable({
		processing: true,
		serverSide: false,
		pageLength: $('#alps-reviews-table').attr('data-number_of_courses'),
		ajax: {
			url: '/wp-admin/admin-ajax.php?action=alps_location_reviews',
			cache: false,
		},
		columns: [
			{
				data: 'rating',
				render: function (data, type, row) {
					return (
						'<div class="alps-review-rating" data-rating="' +
						parseFloat(data) +
						'">' +
						alps_get_rating_stars(data) +
						'</div>'
					);
				},
				orderable: true,
				// Use the numeric value for sorting
				orderData: 0,
			},
			{
				data: 'name',
				render: function (data, type, row) {
					var currentUrl = window.location.href;

					var updatedUrl = currentUrl + '?location_id=' + row.qvalue;

					return '<a href="' + updatedUrl + '">' + data + '</a>';
				},
			},
			{ data: 'popular' },
			// Add other columns you want to display
		],
		// Enable filtering for specific columns (indices start from 0)
		responsive: true,
		columnDefs: [
			{
				targets: 0,
				orderable: true,
				type: 'alps-rating',
			},
			{ targets: [0, 1], searchable: true },
		],
		order: [[columnIndex, defaultOrder]],
		// Custom sorting function
		oSort: {
			'alps-rating-asc': function (a, b) {
				return (
					parseInt(
						$(a).find('.alps-review-rating').data('rating')
					) -
					parseInt(
						$(b).find('.alps-review-rating').data('rating')
					)
				);
			},
			'alps-rating-desc': function (a, b) {
				return (
					parseInt(
						$(b).find('.alps-review-rating').data('rating')
					) -
					parseInt(
						$(a).find('.alps-review-rating').data('rating')
					)
				);
			},
		},
	});
	function alps_get_rating_stars(rating) {
		var full_stars = Math.floor(rating); // Number of full stars
		var half_stars = Math.ceil(rating - full_stars);
		var stars_html = '';

		// Full stars
		for (var i = 0; i < full_stars; i++) {
			stars_html += '<span class="fa-solid fa-star"></span>';
		}

		// Half stars
		for (var i = 0; i < half_stars; i++) {
			stars_html += '<span class="fa-solid fa-star-half-stroke"></span>';
		}

		// Empty stars
		var empty_stars = 5 - (full_stars + half_stars);
		for (var i = 0; i < empty_stars; i++) {
			stars_html += '<span class="fa-regular fa-star"></span>';
		}

		return stars_html;
	}
});
